import { FULL_BLEED_MEDIA_ASPECT_RATIO } from "../../EditLayout/mediaSpecs";
import { HeaderPhotoOrVideo } from "./HeaderPhotoOrVideo";
import { css } from "@emotion/react";
import React, { memo } from "react";

/**
 * Full-bleed media treatment — edge-to-edge photo (legacy l3 / Fullscreen
 * image slot). Design theme does not style this image; layout CSS only.
 */
const styles = {
  image: css`
    aspect-ratio: ${FULL_BLEED_MEDIA_ASPECT_RATIO};
    display: block;
    object-fit: cover;
    width: 100%;
  `,
  photoContainer: css`
    position: relative;
  `,
  // Legacy fancyclothes overlay hook; kept for parity with HorizontalFullHeader.
  shadow: css`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  `,
};

export type FullBleedMediaProps = {
  alt: string;
  headerSlotPosition: number;
  /** Which of photoURL or posterURL/videoURL to render. */
  mediaType: "photo" | "video";
  photoURL: string;
  /** Video poster thumbnail — video only. */
  posterURL?: string;
  /** Playable video src — video only. */
  videoURL?: string;
};

const FullBleedMedia = ({
  alt,
  headerSlotPosition,
  mediaType,
  photoURL,
  posterURL,
  videoURL,
}: FullBleedMediaProps) => (
  <div css={styles.photoContainer}>
    <div css={styles.shadow} />
    <HeaderPhotoOrVideo
      alt={alt}
      headerSlotPosition={headerSlotPosition}
      imageCss={styles.image}
      mediaType={mediaType}
      photoURL={photoURL}
      posterURL={posterURL}
      videoURL={videoURL}
    />
  </div>
);

const MemoizedFullBleedMedia = memo(FullBleedMedia);

export { MemoizedFullBleedMedia as FullBleedMedia };
